import {gsap, SplitText} from "../Utility/gsap";

const getIntroAnimation = (tl) => {
  tl.to('.intro-animation', {
    y:"0%",
    duration:0
  });

  tl.to('.intro-animation .traina-logo', {
    autoAlpha:1,
    y: "0%",
    duration:0.85,
    delay: 0.4,
    ease: "Expo.easeInOut"
  });

  tl.to('.intro-animation .traina-logo .logo-letter', {
    autoAlpha:0,
    y: "-100%",
    stagger: {
      each:.05,
    },
    delay: 0,
    duration:1.5,
    ease: "Expo.easeIn"
  });

  tl.to( '.intro-animation .curtain', {
    delay:-0.15,
    y:"-100%",
    duration: 0.65,
    ease: "Sine.easeInOut"
  })

  tl.to('.intro-animation', {
    y:"-100%",
    duration:0
  });

  tl.from('.site-header a', {
    alpha:0,
    duration:1,
    delay:-0.25,
    ease: "expo.inOut"
  });

  return tl;
}

let matchMediaHero;

const getHeroIntro = (tl, isFirstPlay) =>  {

  const taglineEl = document.querySelector('.hero .hero-logo+.hero-tagline');
  matchMediaHero = matchMediaHero ?? gsap.matchMedia('.hero');

  const matched = matchMediaHero.add({
    //reducedMotion:`(prefers-reduced-motion:reduce)`,
    prefersMotion:`(prefers-reduced-motion:no-preference)`
  },(ctx)=>{
    const {prefersMotion} = ctx.conditions;
    if(prefersMotion){
      tl = tl ?? gsap.timeline();
      const tagline = new SplitText(taglineEl, { type:"words" });

      if( taglineEl && tagline ) {
        tl.to(tagline.words, {
          duration:0,
          autoAlpha:0,
          y:"110%"
        }, 0);
      }

      if( isFirstPlay) {

        gsap.from('.site-header a', {
          alpha:0,
          duration:2,
          delay: 2.25,
          ease: "Sine.easeInOut",
        });
      }

      tl.from('.hero-logo .logo-letter', {
        y: "110%",
        rotate: 10,
        duration:2,
        stagger: 0.05,
        delay:0.25,
        ease: "Expo.easeInOut"
      });

      if( taglineEl && tagline ) {

        tl.to(tagline.words, {
          autoAlpha:1,
          y: "0%",
          duration:1,
          delay:-1.25,
          stagger: 0.1,
          ease: "Expo.easeInOut",
          onStart: () => {
            tagline.elements[0].style.setProperty('clip-path', 'polygon(0 0, 100% 0, 100% 100%, 0 100%)');
          },
          onComplete: () => {
            tagline.elements[0].style.setProperty('clip-path', 'unset');
            // tagline.revert();
          }
        });
      }
      tl.play();

      return ()=>{
        tagline.revert();
      }
    }
  })


  return tl;

}


const InitializeIntroAnimation = () => {

  try {

    const hasPlayed = window.hasPlayed; //JSON.parse( window.sessionStorage.getItem('playedIntro') );

    const tl = gsap.timeline();

    //add the intro cutrain animation
    // if( !hasPlayed ) {
    //   getIntroAnimation(tl);
    // }

    //add the hero animation
    getHeroIntro(tl, !hasPlayed);

    //tl.play();
      
    // window.sessionStorage.setItem('playedIntro', true);
    window.hasPlayed = true;

  } catch(e) {

    console.log(e);

  }

}




export { InitializeIntroAnimation }